module.exports = __webpack_public_path__ + "static/media/p3s4.d0a567ca.jpg";